<template>
    <VModal class="confirm-modal" :ref="`${id}`">
        <p v-if="!archiveType" class="text-center mb-3">
            Are you sure you want to delete {{ title }}?
        </p>
        <p v-else class="text-center mb-3">
            Are you sure you want to archive {{ title }}?
        </p>
        <div class="btn-holder">
            <VButton
                @clickHandler="deleteItem"
                theme="orange"
                active
            >Yes</VButton>
            <VButton
                @clickHandler="hideModal"
                theme="orange"
            >No</VButton>
        </div>
    </VModal>
</template>

<script>
import VModal from "@/components/atoms/VModal.vue";
import VButton from "@/components/atoms/VButton.vue";

export default {
    name: "Confirm",
    components: {
        VModal,
        VButton,
    },
    props: {
        title: String,
        id: String,
        archiveType: Boolean
    },
    emits: ["delete"],
    data() {
        return {};
    },
    methods: {
        deleteItem() {
            this.$emit('delete')
            this.hideModal()
        },
        hideModal() {
            this.$refs[this.id].hideModal()
        }
    },
};
</script>
<style lang="scss">
.confirm-modal .modal.modal-md{
    width: auto;
    height: auto;
}
.btn-holder {
    display: flex;
    justify-content: center;

    .btn {
        margin: 0 5px;
    }
}
</style>
